import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ParentsRespondingPositivelyDuringHouseVisits = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Parents responding positively during house visits (%)" />
    </Box>
  );
};
